// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class LogoutMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_PFIX_LOGOUT_MESSAGE, fieldSet);
    }
    getText() {
        return this.getFieldValue(FieldsFactory.FIELD_TEXT);
    }
    setText(text) {
        this.setFieldValue(FieldsFactory.FIELD_TEXT, text);
    }
    getSessionId() {
        return this.getFieldValue(FieldsFactory.FIELD_SESSIONID);
    }
    setSessionId(sessionId) {
        this.setFieldValue(FieldsFactory.FIELD_SESSIONID, sessionId);
    }
    /// <summary>
    /// для брокера, выбивающего трейдера
    /// </summary>
    setUserId(userId) {
        this.setFieldValue(FieldsFactory.FIELD_USER_ID, userId);
    }
    getErrorCode() {
        return this.getFieldValue(FieldsFactory.FIELD_ERROR_CODE);
    }
    getLogoutType() {
        return this.getFieldValue(FieldsFactory.FIELD_TYPE);
    }
}
